import axios from './axios';

const getBranchDepartments = async (id: string, str = ''): Promise<any> => {
  const params = { id };
  return axios.get(`/branch-department${str}`, { params });
};

export { getBranchDepartments };
